<template>
    <div :class="{'error': errors.has(name) }">
        <label :for="_uid">{{label}}</label>
        <input :id="_uid" :disabled="disabled" :autocomplete="autocomplete" type="text" v-validate :data-vv-rules="validation" :name="name" class="full-txt" placeholder="" v-bind:value='value' v-on:input="$emit('input', $event.target.value)">
        <p class="error" v-if="errors.has(name)">{{ errors.first(name) }}</p>
    </div>
</template>
<script>
export default {
  props: {
    value: {},
    autocomplete: {
      type: String,
      default: "on"
    },
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    validation: {
      type: String,
      default: "required"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  inject: ["$validator"]
};
</script>
